import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { BookingQuestion, BooleanQuestionAnswer, DateAndTimeQuestionAnswer } from 'src/modules/models/regular-portal/booking/question/booking-question';
import { DateAndTimeQuestion } from 'src/modules/models/regular-portal/booking/question/question';
import { Utility } from 'src/modules/utility';
import * as _ from 'lodash'
@Component({
  selector: 'opt-date-time-question',
  templateUrl: './date-time-question.component.html'
})
export class DateTimeQuestionComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() bookingQues: DateAndTimeQuestionAnswer;
  @Input() dates: any[];
  @Output() QuestionAnswerOutput = new EventEmitter();
  @Output() DateSelectedOutput = new EventEmitter();
  displayArrayData: any[] = [];
  @Input() answeredQuestionIds: string[];
  @Input() questionNumber: number;
  isAnswerDate: boolean;
  isAnswerTime: boolean;
  isAnswerDateAndTime: boolean;
  isValidStart: boolean;
  defaultDate:any;
  defaultTime:any;
  minuteStep = environment.MinimumBookingDuration ? environment.MinimumBookingDuration : 1;

  get selectedTime(): Date | null {
    if (!this.bookingQues.tempTime && this.bookingQues.time) {
      this.initializeTempTime();
    }
    
    return this.bookingQues.tempTime;
  }
  
  set selectedTime(value: Date | null) {
    this.bookingQues.tempTime = value;
    if (value) {
      this.timeChanged();
    }
  }
  
  constructor() {
    this.isAnswerDate = false;
    this.isAnswerTime = false;
    this.isAnswerDateAndTime = false;

  }
  ngAfterViewInit(): void {
    let element = document.getElementsByClassName('mat-form-field-flex');
    for (let index = 0; index < element.length; index++) {
      const el = element[index] as HTMLElement;
      el.setAttribute('style', 'height:36px');
    }
  }
  
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['bookingQues'] && changes['bookingQues'].currentValue) {
      const currentValue = changes['bookingQues'].currentValue;
      const previousValue = changes['bookingQues'].previousValue;
      
      if (currentValue.date && currentValue.date !== previousValue?.date) {
        this.addOrRemoveQuestionID(currentValue.id, true);
      }

      if (currentValue.time && currentValue.time !== previousValue?.time) {
        this.initializeTempTime();
        this.addOrRemoveQuestionID(currentValue.id, true);
      }
      
      if (currentValue.time && !currentValue.tempTime) {
        this.initializeTempTime();
      }
    }
  }
  ngOnInit() {
    var thisComponent = this;
    this.displayArrayData.push(this.dates)
    this.isAnswerDate = (this.bookingQues.question as DateAndTimeQuestion).answerDate;
    this.isAnswerTime = (this.bookingQues.question as DateAndTimeQuestion).answerTime;
    this.isAnswerDateAndTime = (this.bookingQues.question as DateAndTimeQuestion).answerDateAndTime;
    this.defaultDate=_.cloneDeep(this.bookingQues.date);
    this.defaultTime=_.cloneDeep(this.bookingQues.tempTime);
    
    if (this.bookingQues.time && !this.bookingQues.tempTime) {
      this.initializeTempTime();
    }
    
    // Check if question is already answered and mark it accordingly
    const isDateAnswered = this.isAnswerDate && this.bookingQues.date != undefined;
    const isTimeAnswered = this.isAnswerTime && this.bookingQues.time != undefined;
    const isDateAndTimeAnswered = this.isAnswerDateAndTime && (this.bookingQues.date != undefined || this.bookingQues.time != undefined);
    
    const isQuestionAnswered = isDateAnswered || isTimeAnswered || isDateAndTimeAnswered;
    
    if (isQuestionAnswered) {
      thisComponent.addOrRemoveQuestionID(this.bookingQues.id, true);
    }
    
    if (this.isAnswerDate && this.bookingQues.date == undefined) {
      // this.bookingQues.date = new Date()
    }
    if (this.isAnswerTime && this.bookingQues.time == undefined) {
      // this.bookingQues.time = moment(new Date()).toDate();
    }
    if (this.isAnswerDateAndTime) {
      if(this.bookingQues.date != undefined) {
        thisComponent.addOrRemoveQuestionID(this.bookingQues.id, true);
      }
      if(this.bookingQues.time != undefined) {
        this.initializeTempTime();
        thisComponent.addOrRemoveQuestionID(this.bookingQues.id, true);
      }
    } 
    if (this.isAnswerTime) {
      if(this.bookingQues.time != undefined) {
        this.initializeTempTime();
        thisComponent.addOrRemoveQuestionID(this.bookingQues.id, true);
      }
    }
    this.bookingQues.conditionalBookingQuestions =
    this.checkConditionalQuestions(this.bookingQues.conditionalBookingQuestions)
    if (this.isAnswerDate) {
      this.bookingQues.time = undefined;
    }
    if (!(this.dates != undefined && this.dates.length > 0))
      this.QuestionAnswerOutput.emit(this.bookingQues);

    if (this.bookingQues.question)
      this.bookingQues.question.undecided = false;
  }
  getDateValue(): Date | null {
    if (!this.bookingQues.date) {
      return null;
    }
    // Convert the stored date string to a Date object for the datepicker
    if (typeof this.bookingQues.date === 'string') {
      // Try direct Date constructor first
      const directDate = new Date(this.bookingQues.date);
      
      // Validate the direct conversion
      if (!isNaN(directDate.getTime()) && directDate.getFullYear() > 1900 && directDate.getFullYear() < 2100) {
        return directDate;
      }
      
      // Fallback to moment if direct conversion fails
      const momentDate = moment(this.bookingQues.date).toDate();
      
      if (!isNaN(momentDate.getTime()) && momentDate.getFullYear() > 1900 && momentDate.getFullYear() < 2100) {
        return momentDate;
      }
      
      return null;
    }
    return this.bookingQues.date;
  }

  initializeTempTime() {
    if (this.bookingQues.time) {
      try {
        const today = new Date();
        const timeString = this.bookingQues.time;
        
        
        let timeDate;
        
        // Check if it's a full datetime string (ISO format)
        if (timeString.includes('T') && timeString.includes(':')) {
          // Handle ISO datetime format like "2025-10-13T16:35:00"
          const fullDate = new Date(timeString);
          if (!isNaN(fullDate.getTime())) {
            // Extract just the time portion and create a new date for today
            timeDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 
                               fullDate.getHours(), fullDate.getMinutes(), 0);
          }
        } else if (timeString.includes(':')) {
          // Handle time-only format like "16:35" or "4:35 PM"
          const [timePart] = timeString.split(' '); 
          const [hours, minutes] = timePart.split(':');
          timeDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 
                             parseInt(hours), parseInt(minutes), 0);
        } else {
          timeDate = moment(timeString, ['HH:mm:ss', 'h:mm A', 'HH:mm']).toDate();
        }
        
        if (!isNaN(timeDate.getTime())) {
          this.bookingQues.tempTime = timeDate;
        }
      } catch (error) {
        try {
          this.bookingQues.tempTime = moment(this.bookingQues.time).toDate();
        } catch (momentError) {
          this.bookingQues.tempTime = new Date();
        }
      }
    }
  }

  getTimeValue(): Date | null {
    if (!this.bookingQues.tempTime) {
      return null;
    }
    if (this.bookingQues.tempTime instanceof Date) {
      return this.bookingQues.tempTime;
    }
    try {
      return new Date(this.bookingQues.tempTime);
    } catch (error) {
      return null;
    }
  }

  getTimeDisplayValue(): string {
    if (!this.bookingQues.tempTime && this.bookingQues.time) {
      this.initializeTempTime();
    }
    
    if (!this.bookingQues.tempTime) {
      return '';
    }

    const timeDate = this.getTimeValue();
    if (timeDate && !isNaN(timeDate.getTime())) {
      const formattedTime = moment(timeDate).format('h:mm A');
      return formattedTime;
    }

  }

  getTimeInputValue(): string {
    if (!this.bookingQues.tempTime && this.bookingQues.time) {
      this.initializeTempTime();
    }
    
    if (!this.bookingQues.tempTime) {
      return '';
    }
    const timeDate = this.getTimeValue();
      if (timeDate && !isNaN(timeDate.getTime())) {
        const formattedTime = moment(timeDate).format('HH:mm');
        return formattedTime;
      }
    
    return '';
  }

  onTimeInputChange(event: any): void {
    const timeValue = event.target.value;
    
    if (timeValue) {
      const [hours, minutes] = timeValue.split(':');
      const hourNum = parseInt(hours);
      const minuteNum = parseInt(minutes);
      
      // Create a proper time string in 12-hour format for storage
      let displayHour = hourNum;
      let ampm = 'AM';
      
      if (hourNum === 0) {
        displayHour = 12; // 00:xx becomes 12:xx AM
      } else if (hourNum === 12) {
        displayHour = 12; // 12:xx stays 12:xx PM
        ampm = 'PM';
      } else if (hourNum > 12) {
        displayHour = hourNum - 12; // 13:xx becomes 1:xx PM
        ampm = 'PM';
      }
      
      // Store the time in 12-hour format 
      this.bookingQues.time = `${displayHour}:${minutes.padStart(2, '0')} ${ampm}`;
      
      const today = new Date();
      const timeDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 
                               hourNum, minuteNum, 0);
      this.bookingQues.tempTime = timeDate;
      
      this.timeChanged(false);
    } else {
      this.bookingQues.tempTime = undefined;
      this.bookingQues.time = undefined;
      this.addOrRemoveQuestionID(this.bookingQues.id, false);
    }
  }


  dateChanged(e) {
    var thisComponent = this;
    
    if (!e.value) {
      this.bookingQues.date = undefined;
      thisComponent.addOrRemoveQuestionID(this.bookingQues.id, false);
      this.bookingQues.conditionalBookingQuestions = this.checkConditionalQuestions(this.bookingQues.conditionalBookingQuestions);
      if (!(this.dates != undefined && this.dates.length > 0))
        this.QuestionAnswerOutput.emit(this.bookingQues);
      return;
    }

    const momentDate = moment(e.value);
    const convertedDate = Utility.convertToISO(Utility.convertISOToDate(momentDate.toDate()));
    
    this.bookingQues.date = convertedDate;
    this.bookingQues.answeredTime = new Date();
    
    if (this.dates != undefined && this.dates.length > 0) {
      this.dates.forEach(function (dt, i) {
        dt.actualQuestionTobePatch.date = this.bookingQues.date;
      });
    }
    
    thisComponent.addOrRemoveQuestionID(this.bookingQues.id, this.bookingQues.date != undefined);
    this.bookingQues.conditionalBookingQuestions = this.checkConditionalQuestions(this.bookingQues.conditionalBookingQuestions);
    
    if (!(this.dates != undefined && this.dates.length > 0))
      this.QuestionAnswerOutput.emit(this.bookingQues);

    if (this.bookingQues.question)
      this.bookingQues.question.undecided = false;
  }
  clearDate(event) {
    event.stopPropagation();
    this.bookingQues.date = this.defaultDate;
    this.bookingQues.tempTime = this.defaultTime;
    this.bookingQues.time = undefined;
    this.bookingQues.answeredTime = new Date();
    
    this.addOrRemoveQuestionID(this.bookingQues.id, this.bookingQues.date != undefined || this.bookingQues.time != undefined);
    
    // Update conditional questions
    this.bookingQues.conditionalBookingQuestions = this.checkConditionalQuestions(this.bookingQues.conditionalBookingQuestions);
    
    // Emit the updated question
    if (!(this.dates != undefined && this.dates.length > 0))
      this.QuestionAnswerOutput.emit(this.bookingQues);
  }
  closeTimeMenu() {

  }
  toTimestamp(strDate){
    var datum = Date.parse(strDate);
    return datum/1000;
 }
  timeChanged(shouldRound: boolean = true) {
    if (this.bookingQues.tempTime != null) {
      // Only convert and potentially round if we don't already have a properly formatted time
      if (!this.bookingQues.time || shouldRound) {
        this.bookingQues.time = Utility.convertDateToTime(this.bookingQues.tempTime)
        
        // Only apply rounding if requested (for programmatic changes, not manual input)
        if (shouldRound) {
          var dtObj = Utility.roundToMinDuration(this.bookingQues.tempTime, environment.MinimumBookingDuration);
          if (dtObj.isDateChanged) {
            this.bookingQues.time = Utility.convertDateToTime(dtObj.newDate)
          }
        }
      }
    }
    var thisComponent = this;
    this.bookingQues.answeredTime = new (Date);
    if (this.dates != undefined && this.dates.length > 0) {
      this.dates.forEach(function (dt, i) {
        dt.actualQuestionTobePatch.time = this.bookingQues.time;
      });
    }
    //else {
    thisComponent.addOrRemoveQuestionID(this.bookingQues.id, this.bookingQues.time != undefined);
    this.bookingQues.conditionalBookingQuestions =
       this.checkConditionalQuestions(this.bookingQues.conditionalBookingQuestions)
    // }
    if (!(this.dates != undefined && this.dates.length > 0))
      this.QuestionAnswerOutput.emit(this.bookingQues);
  }
  conditionalQuestionAnswerChange(val) {
    if(this.bookingQues.conditionalBookingQuestions && this.bookingQues.conditionalBookingQuestions.length > 0) {
      const i = this.bookingQues.conditionalBookingQuestions.findIndex(a => a.id == val.id && a.question.id === val.question.id);
      if(i !== -1)
        this.bookingQues.conditionalBookingQuestions[i] = val;
        this.bookingQues.answeredTime = new (Date);
      this.QuestionAnswerOutput.emit(this.bookingQues);
    }
  }
  checkConditionalQuestions(conditionalQues: BookingQuestion[]) {
    if (conditionalQues) {
      conditionalQues.forEach(bq => {
        bq.bookingConditionalQuestionAnswers.forEach(ansS => {
          const answerDate = Utility.convertToISO(
            Utility.convertISOToDate(moment(ansS.answerDate).toDate())
          );
          if((!!answerDate && !!ansS.answerTime && answerDate === this.bookingQues.date && ansS.answerTime === this.bookingQues.time)
            || (!!answerDate && answerDate === this.bookingQues.date )
            || (!!ansS.answerTime && ansS.answerTime === this.bookingQues.time)
          ) {
            bq.canDisplayQuestion = true;
          } else {
            bq.canDisplayQuestion = false;
          }
        })
      })
    }
    return conditionalQues
  }

  inputCheckChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;

    this.bookingQues.undecided = isChecked;
    if(this.bookingQues.undecided){
      this.bookingQues.answeredTime = undefined;
    }
    this.bookingQues.answeredTime = new Date();

    if (this.dates && this.dates.length > 0) {
        this.dates.forEach((dt) => {
            dt.actualQuestionTobePatch.undecided = isChecked;
            this.addOrRemoveQuestionID(dt.actualQuestionTobePatch.id, isChecked);
        });
    } else {
        this.addOrRemoveQuestionID(this.bookingQues.id, isChecked);
    }

    if (!this.dates || this.dates.length === 0) {
        this.QuestionAnswerOutput.emit(this.bookingQues);
    }
  }

  addOrRemoveQuestionID(bookingId: string, isAnswered: boolean) {
    let index = this.answeredQuestionIds.findIndex(x => x == bookingId);
    if (index >= 0) {
      if (!isAnswered) {
        this.answeredQuestionIds.splice(index, 1)
      }
    } else {
      if (isAnswered) {
        this.answeredQuestionIds.push(bookingId);
      }
    }
  }

  RecveselectedDates(event) {
    this.displayArrayData.push(event);
    this.DateSelectedOutput.emit(event);
  }

}
